/* eslint-disable no-console */
import {Tabs as TabsAnt} from 'antd';
import {TabsType} from 'antd/es/tabs';
import React from 'react';

import {Itabs} from '../../interface/Tab';

const Tabs: React.FC<{
  array: Itabs[];
  defaultKey?: string;
  type?: TabsType;
  noPadding?: boolean;
  hidden?: boolean;
  destroy?: boolean;
  activeKey?: string;
  navBoxContent?: boolean;
  fullWidth?: boolean;
  slide?: boolean;
  setActiveKey?: React.Dispatch<React.SetStateAction<string>>;
}> = ({
  array,
  defaultKey,
  type,
  noPadding = false,
  hidden = false,
  destroy = true,
  navBoxContent = false,
  fullWidth = false,
  slide = false,
  activeKey,
  setActiveKey
}) => {
  return (
    <TabsAnt
      className={`tab ${
        fullWidth
          ? 'noPadding fullWidth'
          : noPadding && navBoxContent
            ? 'noPadding boxWrap'
            : noPadding
              ? 'noPadding'
              : navBoxContent
                ? 'boxWrap'
                : ''
      }`}
      type={type ?? 'card'}
      defaultActiveKey={defaultKey ?? array?.[0]?.id}
      items={array?.map((item) => {
        return {
          label: item.name,
          key: item.id,
          children: (
            <div style={{position: 'relative', height: '100%'}}>
              {item.component}
            </div>
          ),
          disabled: item?.disabled,
          forceRender: item?.forceRender ?? false
        };
      })}
      tabBarGutter={48}
      destroyInactiveTabPane={destroy}
      hidden={hidden}
      tabPosition={slide ? 'left' : 'top'}
      activeKey={activeKey === '' ? array?.[0].id : activeKey}
      onChange={setActiveKey}
    />
  );
};

export default Tabs;
